<template>
  <div class="hangar-ship-root">
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><router-link :to="{ name: 'hangar' }">Ангар</router-link></li>
        <li class="is-active">
          <a>{{ spaceship.name || 'Корабль' }}</a>
        </li>
      </ul>
    </nav>

    <div v-if="loading" class="notification is-light">
      Загрузка…
    </div>

    <div v-else-if="spaceship.id" class="card">
      <div v-if="spaceship.drawing && spaceship.drawing.image" class="card-image">
        <figure class="image is-16by9">
          <img :src="spaceship.drawing.image" :alt="spaceship.name">
        </figure>
      </div>

      <div class="card-content">
        <p class="title is-4">{{ spaceship.name }}</p>
        <p v-if="spaceship.drawing" class="subtitle is-6">
          Чертёж: {{ spaceship.drawing.name }}
        </p>

        <div class="content">
          <p class="title is-5">Параметры</p>
          <div v-if="paramsList.length > 0">
            <p v-for="param in paramsList" :key="param.key">
              <strong>{{ param.label }}:</strong> {{ param.value }}
            </p>
          </div>
          <p v-else class="has-text-grey">Нет параметров</p>

          <p v-if="spaceship.stock_volume != null" class="mt-4">
            <strong>Объём трюма:</strong> {{ spaceship.stock_volume }}
          </p>

          <p class="title is-5 mt-5">Экипировка</p>
          <table v-if="spaceship.spaceship_connectors && spaceship.spaceship_connectors.length > 0" class="table is-fullwidth">
            <thead>
              <tr>
                <th>Размер</th>
                <th>Тип</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="connector in spaceship.spaceship_connectors" :key="connector.id">
                <td>{{ sizeLabel(connector.size) }}</td>
                <td>{{ powerLabel(connector.power) }}</td>
              </tr>
            </tbody>
          </table>
          <p v-else class="has-text-grey">Слоты не установлены</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SpaceshipService from '../services/SpaceshipService'

const SIZE_LABELS = {
  tiny: 'Крошечный',
  small: 'Малый',
  middle: 'Средний',
  large: 'Большой',
  extremally: 'Огромный',
}

const POWER_LABELS = {
  both: 'Двунаправленный',
  consumer: 'Потребитель',
  source: 'Источник',
}

const PARAM_LABELS = {
  strength: 'Прочность',
  volume: 'Объём',
}

export default {
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      spaceship: {},
      loading: false,
    }
  },
  computed: {
    paramsList () {
      const params = this.spaceship.drawing && this.spaceship.drawing.params
      if (!params) return []

      return Object.entries(params).map(([key, value]) => ({
        key,
        label: PARAM_LABELS[key] || key,
        value,
      }))
    },
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler () {
        this.loadSpaceship()
      },
    },
  },
  methods: {
    async loadSpaceship () {
      this.loading = true
      try {
        const resp = await SpaceshipService.getSpaceship(this.$route.params.id)
        this.spaceship = resp.data || {}
      } finally {
        this.loading = false
      }
    },
    sizeLabel (size) {
      return SIZE_LABELS[size] || size
    },
    powerLabel (power) {
      return POWER_LABELS[power] || power
    },
  },
}
</script>

<style scoped>
.hangar-ship-root {
  max-width: 640px;
  margin: 0 auto;
}
</style>
